import { Text } from '@mantine/core';
import { formatFileSize } from './driveFiles';

/**
 * FileSizeCell — ячейка размера файла для RepositoryTable
 * (готового платформенного форматтера размера нет).
 * Без size: наследует базовый шрифт ячейки таблицы, как DateCell/UserCell.
 */
export function FileSizeCell({ value }: { value: number | null | undefined }) {
  return <Text>{formatFileSize(value)}</Text>;
}
